import {gsap} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {WinConfig, WinConfigUtil} from "../../../utils/WinConfigUtil";
import {TheCage} from "../../../TheCage";
import {TheCageGameMode} from "../../../server/TheCageGameMode";
import {RestoreUtils} from "../../../utils/RestoreUtils";
import {TheCageSound} from "../../../sound/TheCageSound";


/**
 * Created by jonas on 2022-01-12.
 */

export class BrokeBankPresentation implements SimplePresentation {

    name:string = "BrokeBankPresentation";

    constructor() {
    }



    shouldRun():boolean {
        return TheCage.model.gameData.brokeTheBank;
    }

    start(controller:SimplePresentationRunnerController):void {
        // TODO clean up once the proper max win animation is ready
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            TheCage.keypadPlugin.setZeroBetSpinCounter(-1);
            TheCage.soundPlayer.setMainToMain1();
            TheCage.soundPlayer.fadeOutMusic(1000);
            TheCage.soundPlayer.playSound(TheCageSound.BROKE_BANK_COUNTUP);
            TheCage.keypadPlugin.setWin(0,true, TheCage.isWinBelowStake(),true);
        });


        tl.add(TheCage.winView.getMaxWinAnimation());
        const countDuration = 8.601;
        const showButtonTime = tl.duration() - 0.57;

        //Count up
        tl.add(TheCage.winView.getMaxWinCountUp(0, TheCage.model.gameData.accumulatedRoundWin, countDuration, 0, new PIXI.Point(360, 125), true, false), '<1.042');
        tl.add(()=>{ TheCage.soundPlayer.playLoopingSound(TheCageSound.BROKE_BANK_LOOP);}, '<8.661');

        //////Countup scale
        //tl.add(TheCage.winView.getCountUpScaleAnimation(0, TheCage.model.gameData.accumulatedRoundWin, countDuration, 0.6, 0.6), 0);

        tl.add(() => TheCage.keypadPlugin.setWin(TheCage.model.gameData.accumulatedRoundWin, true, TheCage.isWinBelowStake()), countDuration);
        tl.add(TheCage.transitionScreen.showMaxWin(), showButtonTime)
        tl.add(TheCage.transitionScreen.enableButton(() => this.onButtonClick(controller)), showButtonTime);


        const hideReelsTl = gsap.timeline();
        hideReelsTl.add(TheCage.reelView.hide(0.3), "<");
        hideReelsTl.add(TheCage.freeSpinReelView.hide(0.3), "<");
        //hideReelsTl.add(Octagon.backgroundElements.setLightLevel(3,0.3), "<")
        hideReelsTl.add(()=>{
            TheCage.backgroundElements.setMode(TheCageGameMode.NORMAL, 0.3);
            TheCage.backgroundElements.showLogo();
            }, "<");

        tl.add(hideReelsTl, 0);

     }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        RestoreUtils.restoreAfterMaxWin();

        const tl:gsap.core.Timeline = gsap.timeline();
        const stayDuration = 0;

        const endSound = TheCageSound.BROKE_BANK_END;
        if (endSound) {

            tl.add(() => TheCage.soundPlayer.stopSound(TheCageSound.BROKE_BANK_LOOP));
            tl.add(() => TheCage.soundPlayer.stopWinSound());
            tl.add(() => TheCage.soundPlayer.playSound(endSound));
        }


        tl.add(() => {
            TheCage.winView.getMaxWinCountUpFade(TheCage.model.winData.accumulatedWin, 0);
        });
        tl.add(TheCage.reelView.show(0.3));
        tl.add([
            TheCage.winView.getBigWinEnd(stayDuration),
            TheCage.winView.getMaxWinCountUpEnd(TheCage.model.winData.accumulatedWin, stayDuration, 0),
            () => TheCage.soundPlayer.fadeInMusic(1000)
        ]);




        tl.add(() => {
            TheCage.soundPlayer.switchMusic(TheCage.model.data.nextMode);
            TheCage.keypadPlugin.setZeroBetSpinCounter(-1);
        });

        tl.add(TheCage.transitionScreen.hideMaxWin());

        tl.add(() => controller.finish());

    }

    private getBigWinLevel(bigWinConfig:WinConfig, duration:number):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();

        tl.add(gsap.to(this,{duration:duration}));
        if (bigWinConfig.anim) {
            tl.add(() => {
                TheCage.winView.getBigWinAnimation(bigWinConfig.anim!, bigWinConfig.particleLevel)
            }, 0);
        }

        return tl;
    }


}